import React, { useEffect, useState } from "react";
import AllCatServiceTabs from "./AllCatServiceTabs";
import { useAuth } from "../../../Store/AuthContext";
import "./DeshBoardPlanCss.css";
import axios from "axios";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function DeshboardAllPlans() {
  // const { RendomTokenfetch } = useAuth();
  // const [AllserviceCat] = AllServicesCategory(RendomTokenfetch);

  const { RendomTokenfetch } = useAuth();
  const [AllserviceCat, setAllServiceCat] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        await axios
          .get(`${WebsiteAPIurl}getallcategory`, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setAllServiceCat(response.data.catdata || []);
            } else {
              setAllServiceCat([]);
            }
          });
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [RendomTokenfetch]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  // console.log(AllserviceCat);
  return (
    <>
      <section className="user-dashboard DeshboardPlans">
        <div className="dashboard-outer DeshboardPlansOuter">
          {/* {AllserviceCat.length > 0 ? (
            <AllCatServiceTabs
              RendomTokenfetch={RendomTokenfetch}
              AllserviceCat={AllserviceCat}
            />
          ) : (
            ""
          )} */}

          {loading ? (
            <APIDataFetchLoader />
          ) : AllserviceCat.length > 0 ? (
            <AllCatServiceTabs AllserviceCat={AllserviceCat} />
          ) : (
            <div className="noCommnetLead text-center py-3 fw-100">
              No Categories Found!
            </div>
          )}
        </div>
      </section>
    </>
  );
}
